import { cva } from '@/styled-system/css';

export const toggleButtonLabelRecipe = cva({
  base: {
    textAlign: 'center',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'color 200ms ease',
    },
  },
  variants: {
    disabled: {
      true: {},
      false: {},
    },
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
    selected: {
      true: {},
      false: {},
    },
    size: {
      sm: {
        textStyle: 'body-sm-bold',
      },
      md: {
        textStyle: 'body-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
  },
  compoundVariants: [
    {
      selected: false,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
          _groupHover: 'text.neutral',
          _groupActive: 'text.neutral',
        },
      },
    },
    {
      selected: false,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
        },
      },
    },
    {
      selected: true,
      disabled: false,
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
          _groupHover: 'text.neutral',
          _groupActive: 'text.neutral',
        },
      },
    },
    {
      selected: true,
      disabled: true,
      loading: false,
      css: {
        color: {
          base: 'text.neutral',
        },
      },
    },
  ],
});
